<template>
    <div>
        <!-- <breadcrumb :items="breadcrumbs"></breadcrumb> -->
        <v-container fluid> 
            <EditGeneticAnimalForm @form-updated="formUpdated" :action="'update'" :animal="animalData"/>
        </v-container>
        <DataLostWarning
            :dialogI="dataLossWarning"
            v-if="dataLossWarning"
            @closeDialog="closeWarningMessage"
            @saveData="closeWarningMessage"  
    ></DataLostWarning>
    </div>
</template>
<script>
import EditGeneticAnimalForm from "./EPDForm.vue" //"./EditGeneticAnimalForm.vue"
import EPDService from "@/_services/EPDService";

export default {
    components: {
        EditGeneticAnimalForm
    },
    mounted() {
        this.getSingleEPD()
    },
    beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}
		next();
	},
    data() {
        return {
            dataLossWarning: false,
            formChanged: false,
            promptToRoute: null,
            animalData: {},
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('Edit Genetics'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
        }
    },
    methods: {
        formUpdated(st) {
            // console.log('ssss', st)
            this.formChanged = st;
        },
        closeWarningMessage(stay) {
            this.dataLossWarning = false;
            if(!stay) {
                this.formChanged = false;
                this.$router.push(this.promptToRoute)
            }
        },
        getSingleEPD() {
            EPDService.getSingleEPD(this.$route.params.geneticid)
            .then((res) => {
                this.animalData = res.data;
            })
            .catch((err) => {
                console.log('err', err)
            })
        }
    }
}
</script>